/** Whether the rail is collapsed to icons, remembered between visits.
 *
 * It is **the person's own choice and nothing else decides it**: not the route (a record page used to
 * collapse it, which moved the whole layout 176px every time a record opened), only the toggle - and,
 * until the person has pressed the toggle, the width of the window (`AppShell`: under 1200px the
 * default is icons, 60px). So the stored value has three states: collapsed (`"1"`), expanded (`"0"`),
 * and never chosen (no key), and an explicit choice - either way - beats the width default.
 *
 * `localStorage` is a per-viewer convenience and nothing more: it throws in a private window, with
 * site data blocked, and in some embedded previews, and the shell must render the same way
 * whichever happens. Every access is inside a `try`, a failed read means "never chosen", and a failed
 * write is dropped - the choice then lasts until the page is closed, which is a smaller loss than a
 * shell that does not render.
 */

export const RAIL_KEY = "emitiq.rail.collapsed";

/** The window width under which an unchosen rail starts as icons. */
export const RAIL_ICONS_BELOW = 1200;

export function readRailChoice(): boolean | null {
  try {
    const stored = window.localStorage.getItem(RAIL_KEY);
    return stored === "1" ? true : stored === "0" ? false : null;
  } catch {
    return null;
  }
}

export function writeRailCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(RAIL_KEY, collapsed ? "1" : "0");
  } catch {
    // Private mode or blocked storage: the choice simply is not remembered.
  }
}
